import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { callApi } from "@shared/api/restApi";
import IconButton from "@mui/material/IconButton";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";

interface SysPwdPopupProps {
  modalRef?: any;
}

const SysPwdPopup = forwardRef(({ modalRef }: SysPwdPopupProps, ref) => {
  const passwordRef = useRef<HTMLInputElement>(null);

  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);

  useEffect(() => {
    passwordRef.current?.focus();
  }, []);

  useImperativeHandle(ref, () => ({
    getSelectedValue: async () => {
      if (!password) {
        return { code: "POPUP_PASSWORD", data: "empty" };
      }
      const result = await checkSysPwd();
      if (result === "error") {
        return { code: "POPUP_PASSWORD", data: "error" };
      } else if (result === true) {
        return { code: "POPUP_PASSWORD", data: true };
      } else {
        return { code: "POPUP_PASSWORD", data: "notConfirm" };
      }
    },
    focusToErrorInput: () => {
      passwordRef.current?.focus();
    },
  }));

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" || e.key === "Tab") {
      e.preventDefault();
      modalRef?.current?.handleConfirm(true);
    }
  };

  const checkSysPwd = async () => {
    const result = await callApi("user/checkSysPassword", {
      password: password,
    });
    const status = result.status;
    if (status) {
      return result.data[0];
    } else {
      return "error";
    }
  };

  return (
    <form className="w-full" autoComplete="off">
      <div className="mb-3">
        <label className="block text-sm mb-1">비밀번호 확인</label>
        <div style={{ position: "relative" }}>
          <input
            ref={passwordRef}
            type={showPwd ? "text" : "password"}
            name="sys_pwd_check"
            autoComplete="new-password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            onKeyDown={handleKeyDown}
            className="w-full border px-2 py-1 rounded"
            style={{ borderColor: "rgb(196 196 196)" }}
          />

          <IconButton
            size="small"
            onClick={() => setShowPwd((prev) => !prev)}
            sx={{
              position: "absolute",
              right: 8,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            {showPwd ? (
              <VisibilityOff fontSize="small" />
            ) : (
              <Visibility fontSize="small" />
            )}
          </IconButton>
        </div>
      </div>
    </form>
  );
});

export default SysPwdPopup;
